<template>
  <v-container class="font-weight-light mx-5" fluid fill-height>
    <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>
    <v-row>
      <!-- GRAPH PREVIEW -->
      <v-col cols="12" md="10" v-if="this.showGraphTypes" :order="bPoint.smAndUp?1:3">
        <v-card>
          <v-tabs fixed-tabs background-color="primary" dark mobile-breakpoint="sm">
            <v-tabs-slider height="4px" color="black"></v-tabs-slider>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('speed')"
            >{{this.getTranslation('Speed')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('rpm')"
              v-if="reportData.isRpmVisible == true"
            >{{this.getTranslation('Rpm')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('engineTemperature')"
              v-if="reportData.isEngineTemperatureVisible == true"
            >{{this.getTranslation('Engine temperature')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('fuelConsumption')"
              v-if="reportData.isFuelConsumptionVisible == true"
            >{{this.getTranslation('Fuel consumption')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('fuelLevelPercentage')"
              v-if="reportData.isFuelLevelPercentageVisible == true"
            >{{this.getTranslation('Fuel level percentage')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('fuelLevel')"
              v-if="reportData.isFuelLevelVisible == true"
            >{{this.getTranslation('Fuel level')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('mileage')"
            >{{this.getTranslation('Mileage')}}</v-tab>
            <v-tab
              class="font-weight-light"
              @click="setGraphTypeValue('combined')"
            >{{this.getTranslation('Combined')}}</v-tab>
          </v-tabs>
          <v-row class="text-right">
            <v-btn
              @click="downloadGraphImage"
              style="margin-top:5px; margin-left:3%;"
              color="#12adcc"
            >
              <v-icon>mdi-download</v-icon>
              {{this.getTranslation('Download graph')}}
            </v-btn>
            <v-btn
              id="resetZoomButton"
              height="37px"
              color="primary"
              style="margin-top:5px; bold:true; color:white; margin-left:1%; visibility:hidden;"
              class="font-weight-light"
              @click="onZoomReset"
            >
              <v-icon dark left>mdi-arrow-left</v-icon>
              {{this.getTranslation('Reset zoom')}}
            </v-btn>
          </v-row>
          <line-chart
            :dataObject="reportData.graphResponse"
            :graphValue="graphValue"
            :zoomChanger="zoomChanger"
            @zoomed="handleZoom"
          ></line-chart>
        </v-card>
      </v-col>
      <v-col v-else md="9" cols="12" lg="10" :order="bPoint.smAndUp?1:3">
        <v-card style="height:200px">
          <p
            id="initialText"
            class="font-weight-light text-h6 text-center"
            style="padding-top:60px"
          >{{initialText}}</p>
        </v-card>
      </v-col>
      <!-- // GRAPH PREVIEW -->

      <!-- FILTER -->
      <v-col cols="12" md="2" order="2">
        <v-card outlined class="mr-5">
          <v-card-text>
            <FilterBuilder
                @apiResponded = onGraphSearch
                :endPoint="endPoint"
                :formElements="elements"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <!-- // FILTER -->
    </v-row>
  </v-container>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import httpClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
import LineChart from '@/views/graphs/GraphGenerator'
import store from '@/store/store'
import FilterBuilder from '@/components/v2/FilterBuilder'
import navigationMixin from '../../components/v2/navigationMixin'

export default {
  data() {
    return {
      isZoomed: false,
      vehicles: [],
      select: {
        vehicleGroups: [],
        vehicles: []
      },
      zoomChanger: false,
      endPoint: 'reports/Graph',
      queryString: '',
      initialText: this.getTranslation('Select filters and search for graphs'),
      startDateMenu: false,
      endDateMenu: false,
      selectedVehicleGroups: [],
      reportData: null,
      searchObject: {
        vehicleId: null,
        startDate: null,
        endDate: null
      },
      showGraphTypes: false,
      graphValue: 'speed',
      showLoading: false,
      elements: [
        {
          key: 'Groups',
          affects: [
            {
              key: 'vehicleId',
              change: {
                type: 'dataSource',
                api: {
                  endpoint: '/vehicles?withModem=trueGroupIds=',
                  associateValue: true
                }
              }
            }
          ],
          cols: 12,
          component: 'v-autocomplete',
          dataSource: { endpoint: '/lookup/vehiclegroups' },
          label: '$groups',
          props: {
            multiple: true
          }
        },
        {
          key: 'VehicleId',
          cols: 12,
          rules:"required",
          component: 'v-autocomplete',
          dataSource: { endpoint: '/vehicles?withModem=true' },
          label: '$vehicles',
          props: {
            multiple: false
          }
        }
      ],
      itemsForNavigation: []
    }
  },
  mixins: [navigationMixin],
  components: {
    LineChart,
    ValidationObserver,
    ValidationProvider,
    DateTimePickerFilter: () =>
      import('@/components/reports/DateTimePickerFilter'),
    FilterBuilder
  },
  methods: {
    handleZoom() {
      this.isZoomed = true
    },
    setGraphTypeValue(value) {
      this.graphValue = value
    },
    onGraphSearch(response) {
      for (let r of response.graphResponse) {
        r.timestamp = formatDate(r.timestamp, 'long', true, false, 'sr-Latn-RS')
      }
      this.reportData = response
      this.isZoomed = false
    },
    getTranslation(value) {
      return translate(value, 'pages.graphs')
    },
    onZoomReset() {
      this.zoomChanger = !this.zoomChanger
      this.isZoomed = false
    },
    downloadGraphImage() {
      var context = document.getElementById('line-chart').getContext('2d')
      let graphDom = context.canvas
      var data = context.getImageData(0, 0, graphDom.width, graphDom.height)
      var compositeOperation = context.globalCompositeOperation
      context.globalCompositeOperation = 'destination-over'
      context.fillStyle = 'white'
      context.fillRect(0, 0, graphDom.width, graphDom.height)
      var img = graphDom.toDataURL('image/jpeg')
      context.clearRect(0, 0, graphDom.width, graphDom.height)
      context.putImageData(data, 0, 0)
      context.globalCompositeOperation = compositeOperation
      var link = document.createElement('a')
      link.href = img
      link.download = img
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  async mounted() {
    httpClient.get('lookup/vehiclegroups').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.id
        }
        this.select.vehicleGroups.push(obj)
      }
    })
    httpClient.get('vehicles').then(response => {
      for (let data of response.data) {
        let obj = {
          text: data.name,
          value: data.id,
          vehicleGroupIds: data.vehicleGroupIds
        }
        this.select.vehicles.push(obj)
        this.vehicles.push(obj)
      }
    })
    this.itemsForNavigation = await this.setBreadcrumbs()
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    }
  },
  watch: {
    reportData: {
      handler() {
        if (this.reportData.graphResponse.length > 0) {
          this.showGraphTypes = true
          let parsedData = []
          let keys = Object.keys(this.reportData.graphResponse[0])
          this.reportData.graphResponse.forEach(data => {
            let singleObjectToAdd = {}
            keys.forEach(key => {
              if (key != 'timestamp') {
                let madeUpKey = ''
                for (let letter in key) {
                  if (letter == 0) {
                    madeUpKey += key[letter].toUpperCase()
                  } else if (key[letter] == key[letter].toUpperCase()) {
                    madeUpKey += ' ' + key[letter].toLowerCase()
                  } else {
                    madeUpKey += key[letter]
                  }
                }
                singleObjectToAdd[this.getTranslation(madeUpKey)] = data[key]
              }
            })
            parsedData.push(singleObjectToAdd)
          })
          localStorage.setItem('reportData', JSON.stringify(parsedData))
        } else {
          this.showGraphTypes = false
          this.initialText = this.getTranslation(
            'No data for provided parameters'
          )
          store.dispatch(
            'notification/add',
            {
              type: 'warning',
              message: this.getTranslation('No data for provided parameters')
            },
            { root: true }
          )
        }
      }
    },
    isZoomed: {
      handler() {
        let zoomButton = document.getElementById('resetZoomButton')
        zoomButton.style.visibility = 'visible'
      }
    }
  }
}
</script>
